import React from 'react'
import ManageBooks from '../manage-books/ManageBooks'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import { routeName } from '../../../../routes/routeName'

type Props = {}

const ManageTheSes = (props: Props) => {
    return (
        <ManageBooks
            menu_name='จัดการวิทยานิพนธ์'
            category={ELibraryCategory.THESIS}
            path_create={routeName.e_library.manage_the_ses_create}
            button_add_name='เพิ่มวิทยานิพนธ์'
        />
    )
}

export default ManageTheSes